import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var MoveAngle = /*#__PURE__*/function () {
  function MoveAngle() {
    _classCallCheck(this, MoveAngle);

    this.offset = 0;
    this.value = 90;
  }

  _createClass(MoveAngle, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.offset !== undefined) {
        this.offset = setRangeValue(data.offset);
      }

      if (data.value !== undefined) {
        this.value = setRangeValue(data.value);
      }
    }
  }]);

  return MoveAngle;
}();